import ColorPickerMicrosoft from "./ColorPickerMicrosoft";

export default ColorPickerMicrosoft;
